export const LEAGUE_STATUSES = {
  ACTIVE: 'active',
  CLOSED: 'closed',
  PLANNED: 'planned',
  INACTIVE: 'inactive',
} as const;

export type LeagueStatus = typeof LEAGUE_STATUSES[keyof typeof LEAGUE_STATUSES];

/**
 * Sync modes accepted by POST /api/leagues/admin/sync.
 * Mirrors LEAGUE_SYNC_MODES in packages/backend/src/routes/leagues.js.
 */
export const LEAGUE_SYNC_MODES = {
  FULL_ACTIVE: 'full-active',
  PENDING: 'pending',
  RECENTLY_CLOSED: 'recently-closed',
  FULL: 'full',
  FULL_LAST_3_YEARS: 'full-last-3-years',
  DEFAULT: 'default',
} as const;

export type LeagueSyncMode = typeof LEAGUE_SYNC_MODES[keyof typeof LEAGUE_SYNC_MODES];
